var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function () {
            var ActualPriceModalWidget = function () {
                function ActualPriceModalWidget() {
                    _classCallCheck(this, ActualPriceModalWidget);

                    this.authPlace = 'actual-price-modal-booking';
                    this.defaultAuthPlace = 'booking';

                    this.selectors = {
                        modalTrigger: '[data-actual-price-modal-trigger]',
                        actualPriceModal: '#actualPriceModal',
                        actualPriceModalBookingButton: '#actualPriceModal .js-create-booking',
                        actualPriceModalHeader: '#actualPriceModal .actual-price-modal__header',
                        actualPriceModalTitle: '#actualPriceModal .actual-price-modal__header .title',
                        actualPriceModalHint: '#actualPriceModal .actual-price-modal__header .hint',
                        openAuthButton: '.js-open-auth-from-actual-price-modal'
                    };
                }

                _createClass(ActualPriceModalWidget, [{
                    key: "init",
                    value: function init() {
                        this.handlers();
                    }
                }, {
                    key: "handlers",
                    value: function handlers() {
                        var _this = this;

                        this.bindSimpleTriggers();

                        if (!window.eventDispatcher || !document.querySelector(this.selectors.actualPriceModal)) {
                            return;
                        }

                        window.eventDispatcher.addEventListener('actualPriceModal:open', function () {
                            _this.open();
                        });

                        window.eventDispatcher.addEventListener('actualPriceModal:resetHeader', function () {
                            _this.resetHeader();
                        });

                        window.eventDispatcher.addEventListener('actualPriceModal:updateHeader', function (data) {
                            _this.updateHeader(data);
                        });

                        window.eventDispatcher.addEventListener('actualPriceModal:submitBooking', function () {
                            _this.submitBooking();
                        });

                        window.eventDispatcher.addEventListener('authSuccessActualPriceModalBooking', function () {
                            _this.syncBookingButtonAfterAuth();
                        });

                        eventDispatcher.addEvent('click', this.selectors.openAuthButton, function (event) {
                            _this.handleAuthClick(event);
                        });
                    }
                }, {
                    key: "bindSimpleTriggers",
                    value: function bindSimpleTriggers() {
                        var _this2 = this;

                        if (!window.eventDispatcher) {
                            return;
                        }

                        eventDispatcher.addAllEvent('click', this.selectors.modalTrigger, function (event) {
                            if (event.currentTarget.matches('.contact-us.js-open-actualPriceModal-callback') && window.brxTracking && typeof window.brxTracking.sendAnalyticsEvent === 'function') {
                                window.brxTracking.sendAnalyticsEvent('click_callback_btn_float');
                            }

                            var modalId = event.currentTarget.dataset.actualPriceModalTrigger;

                            if (!modalId) {
                                return;
                            }

                            _this2.openById(modalId);
                        });
                    }
                }, {
                    key: "submitBooking",
                    value: function submitBooking() {
                        var bookingButton = document.querySelector(this.selectors.actualPriceModalBookingButton);

                        if (!bookingButton) {
                            this.open();

                            return;
                        }

                        bookingButton.click();
                    }
                }, {
                    key: "syncBookingButtonAfterAuth",
                    value: function syncBookingButtonAfterAuth() {
                        var authButton = document.querySelector(this.selectors.openAuthButton);

                        if (!authButton) {
                            return;
                        }

                        authButton.classList.remove('js-open-auth-from-actual-price-modal', 'loader-btn', 'loading');
                        authButton.classList.add('js-create-booking', 'js-create-booking-ab');

                        window.eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: authButton,
                            isShow: false
                        });
                    }
                }, {
                    key: "handleAuthClick",
                    value: function handleAuthClick(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        window.brxTracking.sendAnalyticsEvent('next_step_to_book_auth');

                        if (window.authWidget) {
                            window.authWidget.authPlace = this.authPlace;

                            if (typeof window.authWidget.sendOpenEvent === 'function') {
                                window.authWidget.sendOpenEvent();
                            }
                        }

                        if (window.modal && typeof window.modal.close === 'function') {
                            window.modal.close('.modal2');
                        }

                        this.openAuthModal();
                    }
                }, {
                    key: "openAuthModal",
                    value: function openAuthModal() {
                        var _this3 = this;

                        window.setTimeout(function () {
                            var authModal = document.getElementById('auth-modal');

                            if (!authModal || typeof Modal === 'undefined') {
                                return;
                            }

                            window.modals = { auth: new Modal({ el: authModal }).show() };

                            var authModalInstance = window.modals.auth;

                            if (authModalInstance && typeof authModalInstance.on === 'function') {
                                authModalInstance.on('hidden', function () {
                                    _this3.resetAuthPlace();
                                });
                            }

                            var phoneInput = document.querySelector('.auth-form__phone');

                            if (phoneInput) {
                                phoneInput.focus();
                            }
                        }, 0);
                    }
                }, {
                    key: "resetAuthPlace",
                    value: function resetAuthPlace() {
                        if (window.authWidget && window.authWidget.authPlace === this.authPlace) {
                            window.authWidget.authPlace = this.defaultAuthPlace;
                        }
                    }
                }, {
                    key: "open",
                    value: function open() {
                        this.openById('actualPriceModal');
                    }
                }, {
                    key: "openById",
                    value: function openById(modalId) {
                        if (!window.modal || typeof window.modal.open !== 'function') {
                            return;
                        }

                        var content = document.getElementById(modalId);

                        if (!content) {
                            return;
                        }

                        window.modal.open({
                            header: null,
                            content: { htmlDetachSelectorId: modalId },
                            parentCssClass: 'actual-price-modal',
                            type: window.modal.types.FLOATING,
                            footer: null
                        });
                    }
                }, {
                    key: "resetHeader",
                    value: function resetHeader() {
                        var header = document.querySelector(this.selectors.actualPriceModalHeader);
                        var title = document.querySelector(this.selectors.actualPriceModalTitle);
                        var hint = document.querySelector(this.selectors.actualPriceModalHint);

                        if (!header || !title || !hint) {
                            return;
                        }

                        header.classList.remove('price-up', 'price-down');
                        header.classList.add('actual');
                        title.textContent = 'Цена актуальна';
                        hint.textContent = 'Успейте забронировать по этой цене';
                    }
                }, {
                    key: "updateHeader",
                    value: function updateHeader() {
                        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        var status = data.status || 'actual';
                        var priceDifference = data.priceDifference || 0;
                        var currencySign = data.currencySign || '';
                        var header = document.querySelector(this.selectors.actualPriceModalHeader);
                        var title = document.querySelector(this.selectors.actualPriceModalTitle);
                        var hint = document.querySelector(this.selectors.actualPriceModalHint);

                        if (!header || !title || !hint) {
                            return;
                        }

                        header.classList.remove('actual', 'price-up', 'price-down');
                        header.classList.add('actual');
                        title.textContent = 'Цена актуальна';
                        hint.textContent = 'Успейте забронировать по этой цене';

                        if (status === 'price-up') {
                            var formattedDifference = Number(priceDifference).toLocaleString('ru-RU');

                            header.classList.remove('actual');
                            header.classList.add('price-up');
                            title.textContent = ("\u0426\u0435\u043D\u0430 \u043F\u043E\u0432\u044B\u0441\u0438\u043B\u0430\u0441\u044C \u043D\u0430 " + formattedDifference + " " + currencySign).trim();
                            hint.textContent = 'Проверьте новую цену и завершите бронирование';
                        }

                        if (status === 'price-down') {
                            var _formattedDifference = Number(priceDifference).toLocaleString('ru-RU');

                            header.classList.remove('actual');
                            header.classList.add('price-down');
                            title.textContent = ("\u0426\u0435\u043D\u0430 \u043F\u043E\u043D\u0438\u0437\u0438\u043B\u0430\u0441\u044C \u043D\u0430 " + _formattedDifference + " " + currencySign).trim();
                            hint.textContent = 'Отлично, тур стал выгоднее. Можете бронировать';
                        }
                    }
                }]);

                return ActualPriceModalWidget;
            }();

            new ActualPriceModalWidget().init();
        })();
    }, {}] }, {}, [1]);